import { HttpMethod } from 'api/constants';
export const commuteSectionCategoriesEndpoints = {
  [HttpMethod.Get]: {
    All: '/commute-section-categories'
  },
  [HttpMethod.Put]: {
    Order: {
      path: '/commute-section-categories/order',
      route(): string {
        return this.path;
      }
    }
  }
};
export default commuteSectionCategoriesEndpoints;